import { render, staticRenderFns } from "./NsCurrencyTextField.vue?vue&type=template&id=0b9742c1&"
import script from "./NsCurrencyTextField.vue?vue&type=script&lang=js&"
export * from "./NsCurrencyTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports